<template>
    <div class="center" id="homeTab">
        <div class="center-blue"></div>
        <div class="center-name">交流专区</div>
        <!-- 发帖按钮 -->
        <publish-btn class="center-pub-btn" @add="addTopic"></publish-btn>
        <div class="center-tab">
            <div class="center-tab-name">问题反馈</div>
           <!-- 头部 tag 数组展现 -->
            <div v-if="tagInfo && tagInfo.length"
                class="center-list-tags">
                <span v-for="item in tagInfo"
                    :key="item.id"
                    :class="{'center-list-tags-item': true, 'center-list-tags-item-active': activeTag===item.id}"
                    @click="chooseTag(item.id, item.name)">{{item.name}}
                    <span v-if="item.id > 0"
                        class="center-list-tags-item-tip">{{item.tip}}</span>
                </span>
            </div>
            <!-- 技术支持、rd审核员、管理员角色权限 -->
            <topic-filter v-if="hasOfficialPermission"></topic-filter>
        </div>

        <div style="position: relative;min-height: 420px;">
            <div class="center-change-loading" v-if="isLoading">
                <!-- 非小程序端，tag 切换时候，用 loading 的按钮代替加载效果 -->
                <ui-button
                    class="center-change-loading-icon"
                    :loading="true"
                    ui="alt"
                    text="loading"
                >
                </ui-button>
                <!-- 小程序端，展示个 loading 文本 -->
            </div>
            <!-- 如果没有帖子，展示错误图片 -->
            <div v-if="topicList.length === 0" class="center-list-empty">
                <img class="center-list-empty-img" :src="emptyImg">
            </div>
            <!-- 有帖子，加载帖子 list 循环创建 单个 topic-list -->
            <div v-else class="center-hover" v-for="list in topicList" :key="list.topicId">
                <div class="center-list">
                    <topic-list :listWidth="listWidth"
                        :list="list"
                        :isShowTag="activeTag === 0"
                        :isShowExt="isShowExt"
                        @refreshList="refreshList"
                    ></topic-list>
                </div>
            </div>
        </div>

        <!-- 分页器设置 -->
        <div class="center-list-page">
            <page-component v-if="pageInfo.recordTotal > pageInfo.pageSize"
                class="center-list-page-form"
                :pageInfo="pageInfo"
            ></page-component>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/home/main-content.less';
</style>

<script>
import PublishBtn from '@/components/PublishBtn.vue';
import TopicList from '@/views/components/TopicList.vue';
import TopicFilter from '@/views/components/topic-filter';
import Page from '@/views/components/page';
import Button from '@/components/ui-icon/button';
import Icon from '@/components/ui-icon/icon';
import {mapState, mapGetters, mapMutations} from 'vuex';
import {throttle} from '@/utils/debounceThrottle';
import toast from '@/utils/decorate/toast';
import {Tip} from '@/utils/errorCode';
import {sendLog} from '@/utils/osReport';

export default {
    props: {
        topicList: {
            'type': Array,
            'default': () => []
        },
        tagInfo: {
            'type': Array,
            'default': () => []
        },
        pageInfo: {
            'type': Object,
            'default': () => {}
        }
    },
    components: {
        'publish-btn': PublishBtn,
        'topic-list': TopicList,
        'topic-filter': TopicFilter,
        'ui-button': Button,
        'page-component': Page
    },
    metaInfo() {
        return {
            title: `${this.metaContentTitle} - 智能小程序开源社区`,
            meta: [{
                name: 'keywords',
                content: `${this.fixedWords},${this.metaContentTitle}`
            }, {
                name: 'description',
                content: `${this.fixedWords},${this.metaContentTitle}`
            }]
        };
    },
    data() {
        return {
            listWidth: '100%',
            emptyImg: require('../../../assets/images/list/emptyList.png'),
            editUrl: '',
            dialogTableVisible: false,
        };
    },
    computed: {
        ...mapState({
            isLoading: state => state.home.isLoading,
            fixedWords: state => state.common.metaInfo.fixedWords,
            activeTag: state => state.home.activeTag,
            activeSort: state => state.home.activeSort
        }),
        ...mapGetters([
            'hasOfficialPermission'
        ]),
        isShowExt() {
            // 系统管理员权限
            if (this.hasOfficialPermission instanceof Array) {
                return true;
            }
            return this.hasOfficialPermission;
        },

        /**
         * 获取网页标题
         */
        metaContentTitle() {
            let newName;
            this.tagInfo.forEach((item, index) => {
                if (item.id === this.activeTag) {
                    newName = item.name;
                }
            });
            return newName;
        }
    },
    methods: {
        ...mapMutations([
            'changeActiveTag',
            'changeActiveSort'
        ]),
        reportMethod(eventType, clickName) {
            sendLog({
                eventName: '点击发贴',
                eventCode: 'add_topic',
                eventType,
                clickName
            });
        },
        chooseTag(id, tagName) {
            this.changeActiveTag(+id);
            let that = this;
            this.$router.push({
                name: 'homeTab',
                query: {
                    tagId: that.activeTag,
                }
            });
            if (this.hasOfficialPermission) {
                this.$store.dispatch('clearFilterState');
            }
        },
        addTopic() {
            if (this.$store.state.header.isLogin) {
                if (this.$store.state.header.isBanned) {
                    toast.error(Tip.banned);
                    // 被禁言了
                }
                else {
                    // 打点测试
                    this.reportMethod(2, '发帖');
                    this.$store.dispatch('clickPost')
                        .then(() => {
                            this.$router.push({name: 'addTopic'});
                        });
                }
            }
            else {
                this.$store.dispatch('navToExit');
            }
        },
        load: throttle(function (type, isPageTurn) {
            if (type === 'more') {
                this.loadMore();
            }
            else {
                this.loadLess(isPageTurn);
            }
        }),
        loadMore() {
            let params;
            let query;
            params = Object.assign({}, this.$route.params);
            query = Object.assign({}, this.$route.query);
            this.$store.dispatch('getMainList', {params, query, loadMore: true});
        },
        loadLess(isPageTurn) {
            let params = Object.assign({}, this.$route.params);
            let query = Object.assign({}, this.$route.query);
            // 如果是翻页组件，获取当前数据的页码
            if (isPageTurn) {
                // 页码相同不触发 watch，手动请求接口
                if (+query.pageNo === +this.pageInfo.pageNo) {
                    this.$store.dispatch('getMainList', {params, query, loadMore: false});
                    return;
                }
                query.pageNo = this.pageInfo.pageNo;
                this.$router.push({name: 'homeTab', params, query});
            }
            // 如果是loadMore组件，数据从首页开始
            else {
                query.pageNo = 1;
                this.$store.dispatch('getMainList', {params, query, loadMore: false});
            }
        },
        refreshList() {
            this.$store.dispatch('getMainList', {params: this.$route.params, query: this.$route.query});
        }
    },
    beforeDestroy() {
        if (this.hasOfficialPermission) {
            this.$store.dispatch('clearFilterState');
        }
    }
};
</script>
